import React, { useRef, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import axios from "axios";
import { API_BULK_CREATE_PROJECT } from "../../config/Endpoints";
import { useNavigate } from "react-router-dom";

const CreateBulkProject = () => {
  const modalBtnRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);

  const formDataInitialState = { file: "" };
  const [formData, setFormData] = useState(formDataInitialState);

  const accessToken = Cookies.get("accessToken");
  const navigate = useNavigate();

  const acceptedFileType = [
    { type: "application/vnd.ms-excel", label: ".xls" },
    {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      label: ".xlsx",
    },
  ];

  const acceptedFileTypesMessage = acceptedFileType
    .map((item) => item.label)
    .join(", ");

  const maxFileSizeInMB = 2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const file = formData.file;

    const payload = new FormData();
    payload.append("file", file);

    try {
      const res = await axios.post(API_BULK_CREATE_PROJECT, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(
        res.data?.message
          ? `${res.data.message}`
          : `${file.name} uploaded successfully.`,
        { position: toast.POSITION.TOP_RIGHT }
      );

      handleReset();
      navigate("/dashboard/projectList");
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Something went wrong. Please try again!",
        { position: toast.POSITION.TOP_RIGHT }
      );
    } finally {
      setIsLoading(false);
      fileInputRef.current.value = null;
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = acceptedFileType.map((item) => item.type);
    if (!allowedTypes.includes(file.type)) {
      toast.error(
        `Invalid file type! Please upload ${acceptedFileTypesMessage} file only.`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      fileInputRef.current.value = null;
      return;
    }

    if (file.size > maxFileSizeInMB * 1024 * 1024) {
      toast.error(`File size should not exceed ${maxFileSizeInMB} MB.`, {
        position: toast.POSITION.TOP_RIGHT,
      });
      fileInputRef.current.value = null;
      return;
    }

    setFormData({ file });
  };

  const handleReset = () => {
    setFormData(formDataInitialState);
    fileInputRef.current.value = null;
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="px-2 py-4">
          <div className="d-flex justify-content-center align-items-center">
            <div style={{ width: "min(500px, 100%)" }}>
              <div className="inputs">
                <div className="input-group">
                  <label htmlFor="bulkProjectFile" className="has-asterisk">
                    Bulk Project File
                  </label>
                  <input
                    type="file"
                    name="file"
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                    ref={fileInputRef}
                  />
                  <small className="text-danger mt-1">
                    Note: Please upload valid{" "}
                    <strong>{acceptedFileTypesMessage}</strong> file only
                    {maxFileSizeInMB > 0 && (
                      <span>
                        {" "}
                        (max <strong>{maxFileSizeInMB} MB</strong>)
                      </span>
                    )}
                    .
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div className="action text-center mt-5 position-relative d-flex align-items-center">
            <button
              className={
                isLoading
                  ? "theme-button disabled mx-auto"
                  : "theme-button mx-auto"
              }
              type="submit"
            >
              {isLoading ? (
                <ThreeDots
                  height="25"
                  width="80"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  visible={true}
                />
              ) : (
                "Submit"
              )}
            </button>

            <a
              href="../../../assets/Bulk_Upload_Format.xlsx"
              download
              className="position-absolute end-0"
            >
              <div className="d-flex justify-content-end align-items-center">
                <span>Bulk Upload Format</span>
                <img
                  width="30"
                  height="30"
                  src="https://img.icons8.com/ios/50/export-excel.png"
                  alt="export-excel"
                  title="Download Sample File"
                />
              </div>
            </a>
          </div>
        </div>
      </form>

      <button
        className="open-modal-upload"
        data-bs-toggle="modal"
        data-bs-target="#bulk-project-modal"
        style={{ display: "none" }}
        ref={modalBtnRef}
      >
        click
      </button>
    </div>
  );
};

export default CreateBulkProject;
